// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    '已移动 ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '。',
  accButtonProgressComplete: (p: { label: string }) => '已完成 ' + p['label'] + ' 操作',
  accButtonProgressStatus: (p: { label: string }) => '正在执行 ' + p['label'] + ' 操作',
  accColorPalette: () => '调色板',
  accColorSwatch: () => '颜色样本',
  accCommandKey: () => '命令',
  accContextMenuLabel: () => '操作',
  accControlKey: () => '关闭',
  accPositionAfter: () => '后于',
  accPositionBefore: () => '前于',
  accReorderInstructions: (p: { keyPressed: string }) =>
    '按住 ' + p['keyPressed'] + ' 和 Shift 键，然后使用方向键重新排序。',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    '请输入类似以下示例的完整日期：' + p['dateExample'] + '。',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    '请输入类似以下示例的月和年：' + p['dateExample'] + '。',
  chart_labelDataLabel: () => '标签',
  chart_labelGroup: () => '组',
  chart_labelSeries: () => '系列',
  chart_labelValue: () => '值',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => '选择一个值。',
  checkbox_helpForCheckbox: () => '复选框的帮助',
  checkbox_requiredMessageDetail: () => '选择一个值。',
  checkbox_selected: () => '复选框已选中',
  checkbox_unselected: () => '复选框未选中',
  close: () => '关闭',
  collection_apply: () => '应用',
  collection_cancel: () => '取消',
  collection_loaded: () => '已加载',
  collection_loading: () => '正在加载',
  collection_noData: () => '没有可显示的数据。',
  collection_pixels: () => '像素',
  collection_resizeColumnDialog: () => '调整列大小',
  collection_resizeColumnMenu: () => '调整列大小...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    '输入介于 ' + p['MIN'] + ' 与 ' + p['MAX'] + ' 之间的数字。',
  collection_selectAllRows: () => '选择所有行',
  collection_selectRow: (p: { ROW_NAME: string }) => '选择行 ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => '升序',
  collection_sortColumnMenu: () => '排序列',
  collection_sortDescendingSubMenu: () => '降序',
  collection_sortDisabled: () => '不可排序',
  collection_sortEnabled: () => '可排序',
  collection_width: () => '宽度',
  colorPicker_label: () => '颜色选择器',
  confirmation: () => '确认',
  datePicker_currentDate: () => '当前日期',
  datePicker_goToToday: () => '转到今天',
  datePicker_label: () => '日期选择器',
  datePicker_month: () => '月',
  datePicker_months: () => '月',
  datePicker_next: () => '下一个',
  datePicker_nextDecade: () => '后十年',
  datePicker_nextMonth: () => '下个月',
  datePicker_prev: () => '上一个',
  datePicker_prevDecade: () => '前十年',
  datePicker_prevMonth: () => '上个月',
  datePicker_restricted: () => '受限制',
  datePicker_selected: () => '选定',
  datePicker_today: () => '今天',
  datePicker_weekNum: (p: { NUM: string }) => '第 ' + p['NUM'] + ' 周',
  datePicker_weekNumColLabel: () => '周数',
  datePicker_year: () => '年',
  datePicker_years: () => '年',
  diagram_promotedLink: () => '1 个链接',
  diagram_promotedLinkAriaDesc: () => '间接',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' 个链接',
  error: () => '错误',
  expandableList_expandCollapseInstructionText: () => '使用箭头键展开和折叠',
  expandableList_groupCollapse: () => '折叠',
  expandableList_groupExpand: () => '展开',
  filePicker_addFiles: () => '添加文件',
  filePicker_dropzonePrimaryText: () => '拖放',
  filePicker_dropzoneSecondaryText: () => '选择一个文件或将文件放置在此处',
  filePicker_dropzoneSecondaryTextMultiple: () => '选择文件或将文件放置在此处。',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    '无法上载以下类型的文件: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => '一次上载一个文件',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    '无法上载以下类型的文件: ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => '未知',
  formControl_clear: () => '清除',
  formControl_day: () => '天',
  formControl_empty_segment: () => '空',
  formControl_helpAvailable: () => '帮助可用',
  formControl_hide: () => '隐藏',
  formControl_hour: () => '小时',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    '您已达到 ' +
    ((
      { one: new Intl.NumberFormat('zh-Hans').format(p['CHARACTER_LIMIT']) + ' 个字符' } as Partial<
        Record<Intl.LDMLPluralRule, string>
      >
    )[new Intl.PluralRules('zh-Hans').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('zh-Hans').format(p['CHARACTER_LIMIT']) + ' 个字符') +
    ' 的限制。',
  formControl_loading: () => '正在加载',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    '最多可以输入 ' + p['MAX_LENGTH'] + ' 个字符。',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    '超过了最大长度 ' + p['MAX_LENGTH'] + '。',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    '剩余 ' + p['CHARACTER_COUNT'] + ' 个字符。',
  formControl_millisecond: () => '毫秒',
  formControl_minute: () => '分钟',
  formControl_month: () => '月',
  formControl_readOnly: () => '只读',
  formControl_requiredMessageDetail: () => '输入值。',
  formControl_second: () => '秒',
  formControl_selectionExactMessageDetail: (p: { n: string }) => '选择 ' + p['n'] + ' 个值。',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    '您已达到最多 ' + p['max'] + ' 个的选择限制。',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    '选择 ' + p['min'] + ' 到 ' + p['max'] + ' 个值。',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    '至少选择 ' + p['min'] + ' 个值。',
  formControl_show: () => '显示',
  formControl_year: () => '年',
  gantt_labelDate: () => '日期',
  gantt_labelEnd: () => '结束',
  gantt_labelLabel: () => '标签',
  gantt_labelRow: () => '行',
  gantt_labelStart: () => '开始',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '。未找到匹配的区段。',
  indexer_keyboardInstructionText: () => '按 Enter 键以选择值。',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    '介于 ' + p['FROM_SECTION'] + ' 到 ' + p['TO_SECTION'] + ' 之间',
  indexer_touchInstructionText: () => '双击并按住以进入手势模式, 然后向上或向下拖动以调整值。',
  info: () => '信息',
  inputColor_selectColor: () => '选择颜色',
  inputDateMask_date_cleared: () => '清除日期',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => '空',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    '请输入不晚于 ' + p['max'] + ' 的日期。',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    '请输入不早于 ' + p['min'] + ' 的日期。',
  inputDatePicker_dateRestrictionMessageDetail: () => '请输入可用日期。',
  inputDatePicker_instruction: () => '按 Tab 键可访问日历。',
  inputDatePicker_selectDate: () => '选择日期',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    '请输入不晚于 ' + p['max'] + ' 的月和年。',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    '请输入不早于 ' + p['min'] + ' 的月和年。',
  inputNumber_converterParseError: () => '请输入数字。',
  inputNumber_decrease: () => '减少',
  inputNumber_increase: () => '增加',
  inputPassword_hidden: () => '密码已隐藏',
  inputPassword_hide: () => '隐藏密码',
  inputPassword_show: () => '显示密码',
  inputSensitiveText_hidden: () => '隐藏敏感文本',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    '请输入不晚于 ' + p['max'] + ' 的时间。',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    '请输入不早于 ' + p['min'] + ' 的时间。',
  inputTimeMask_time_cleared: () => '清除时间',
  labelNone: () => '无',
  list_msgFetchCompleted: () => '已加载',
  list_msgFetchingData: () => '正在加载',
  list_suggestion: () => '建议',
  menu_stateLoading: () => '正在加载',
  messageToast_allMessagesClosed: () => '所有快显 (toast) 消息都已关闭。',
  message_close: () => '关闭',
  message_confirmation: () => '成功',
  message_error: () => '错误',
  message_info: () => '信息',
  message_navigationFromMessagesRegion: () => '进入消息区域。按 F6 可导航。',
  message_navigationToMessagesRegion: () => '消息区域有新消息。按 F6 可导航。',
  message_navigationToTouch: () => '消息区域有新消息。',
  message_warning: () => '警告',
  noData_message: () => '没有要显示的项',
  overflowItemLabel: () => '更多选项卡',
  plural_separator: () => ', ',
  popup_close_skipLink: () => '双击以关闭打开的弹出式窗口。',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    '正在进入弹出式窗口。按 F6 可在弹出式窗口和相关控件之间导航。',
  popup_liveRegion_F6_initial_focus_none: () =>
    '弹出式窗口已打开。按 F6 可在弹出式窗口和相关控件之间导航。',
  progressIndeterminate: () => '进行中',
  radioButton_checked: () => '单选按钮已选中',
  radioButton_selected: () => '单选按钮已选定',
  radioButton_unchecked: () => '单选按钮未选中',
  radioButton_unselected: () => '单选按钮未选定',
  radio_helpForRadio: () => '单选按钮帮助',
  radio_requiredMessageDetail: () => '选择一个值。',
  selectMultiple_apply: () => '应用',
  selectMultiple_back: () => '返回',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () => '使用向左和向右方向键突出显示所选值。',
  selectMultiple_removeSelectedTagInstructionText: () => '按 Backspace 或 Delete 键删除所选值。',
  selectMultiple_selectedValues: () => '所选值',
  selectMultiple_showSelectedValues: () => '仅显示选定值。',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    '已选择 ' + p['VALUE_COUNT'] + ' 个值。',
  select_addToList: () => '添加到列表',
  select_addToListAvailable: () => '添加到列表可用',
  select_closeDropdown: () => '按 Esc 键关闭。',
  select_moreSearchOptions: () => '更多搜索选项',
  select_moreSearchOptionsAvailable: () => '更多搜索选项可用',
  select_noMatchesFound: () => '找不到匹配项。',
  select_oneMatchFound: () => '找到一个匹配',
  select_requiredMessageDetail: () => '选择一个值。',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => '找到 ' + p['TOTAL_SIZE'] + ' 个匹配项',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    '找到 ' + p['TOTAL_SIZE'] + ' 个或更多匹配项',
  selectorAll_deselectAll: () => '取消全选',
  selectorAll_selectAll: () => '全选',
  selector_selected: () => '复选框已选中',
  selector_unselected: () => '复选框未选中',
  sheet_close: () => '关闭',
  switch_off: () => '禁用',
  switch_on: () => '启用',
  tabBarNavigationList_removeCueText: () => '可删除',
  tabBar_tabContainsErrors: () => '包含错误',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => '已删除 ' + p['itemKey'],
  tabbar_labelContextMenu: () => '具有上下文菜单',
  tabbar_labelMoveLeft: () => '左移',
  tabbar_labelMoveRight: () => '右移',
  tabbar_labelRemove: () => '删除',
  timeComponent_tooltipZoomIn: () => '放大',
  timeComponent_tooltipZoomOut: () => '缩小',
  timeConverter_parseError: () => '输入完整时间。',
  train_current: () => '当前',
  train_message_type: () => '消息类型',
  train_not_visited: () => '未访问',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    '第 ' + p['currentStep'] + ' 步，共 ' + p['numberOfSteps'] + ' 步',
  train_visited: () => '已访问',
  userAssistance_learnMore: () => '了解更多',
  userAssistance_required: () => '必需',
  vis_clearSelection: () => '清除选择',
  vis_drillable: () => '可钻取',
  vis_invalidData: () => '数据无效',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' 个，共 ' + p['totalCount'] + ' 个',
  vis_marqueeSelectTooltip: () => '选取框选择',
  vis_marqueeZoomTooltip: () => '选取框缩放',
  vis_noData: () => '没有可显示的数据',
  vis_panTooltip: () => '平移',
  vis_stateCollapsed: () => '折叠',
  vis_stateExpanded: () => '展开',
  vis_stateLoaded: () => '已加载',
  vis_stateLoading: () => '正在加载',
  vis_stateSelected: () => '选定',
  vis_stateUnselected: () => '未选定',
  warn: () => '警告'
};
export default bundle;
